import institutioncouncil1 from "../../../assets/CampuLifeImages/institutioncouncil1.jpg"
import institutioncouncil2 from "../../../assets/CampuLifeImages/institutioncouncil2.jpg"
import institutioncouncil3 from "../../../assets/CampuLifeImages/institutioncouncil3.jpg"
import CampusSkillEnhanceDynamic from '../../CampusSharedComponent/CampusDynamicPages/CampusSkillEnhanceDynamicPage/CampusSkillEnhanceDynamic';



const InstitutionInnovation = () => {

            
        const hoverContent =[
          {  img:institutioncouncil1, para1: "National Science Day Celebration,March 03, 2024" },
          {  img: institutioncouncil3, para1: "Entreprenuer Day Celebration , 2024"},
              ]
      const data = {
             name: "Institution Innovation Council", 
        viewmore:"true",
        viewless:"true",
        title: "Institution Innovation Council Activities",
        contentImg: institutioncouncil2,
        contentparaTitle:"Scheme of Shelter for Urban Homeless:",
        contentpara:"Under the National Urban Livelihoods Mission (NULM), the Scheme of Shelter for Urban Homeless addresses the housing needs of those without homes in urban areas.Self Help Group Formation TNULM envisages universal social mobilization of urban poor and vulnerable sections into Self Help Groups (SHGs) and their federations.",
        para:"In the year 2018, the Ministry of Education (MoE) through MoE’s Innovation Cell (MIC) launched the Institution’s Innovation Council (IIC) program in collaboration with AICTE for Higher Educational Institutions (HEIs) to systematically foster the culture of innovation and start-up ecosystem in education institutions. Primarily, IICs’ role is to engage large number of faculty, students and staff in various innovation and entrepreneurship related activities such as ideation, Problem solving, Proof of Concept development, Design Thinking, IPR, project handling and management at Pre-incubation/Incubation stage, etc., so that innovation and entrepreneurship ecosystem gets established and stabilized in HEIs.",
        twohover:true
      }
  return (
    <>
    
    <CampusSkillEnhanceDynamic data={data} content={hoverContent} />

  </>
  )
}

export default InstitutionInnovation





  
  
   